import { IChannel, IProgram } from '../types';

export function findCatchupInChannel(
  channel: IChannel,
  catchupTime: number
): IProgram | null {
  let result: IProgram | null = null;
  const { programs } = channel;
  if (programs) {
    for (let i = 0, l = programs.length; i < l; ++i) {
      if (
        catchupTime >= programs[i].startTimestamp &&
        catchupTime <= programs[i].endTimestamp
      ) {
        result = programs[i];
        break;
      }
    }
  }
  return result;
}
